exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-landing {\r\n    margin-top: -10px;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    app-landing {\r\n        margin-top: 15px;\r\n    }\r\n    .product-profile-mobile {\r\n        padding: 0;\r\n    }\r\n    .ratingProgress .rateParamValue {\r\n        margin-left: 5px;\r\n        left: unset !important;\r\n    }\r\n    .info-desc {\r\n        font-weight: 500;\r\n        font-size: 9px !important;\r\n    }\r\n}\r\n\r\n.info-desc {\r\n    margin: auto;\r\n    font-size: 19px;\r\n    color: #4a2a72;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    display: inline-block;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/landing-brand/landing-brand.component.css
// module id = ../../../../../src/app/pages/landing-brand/landing-brand.component.css
// module chunks = main